/*
* Grid
* https://naver.github.io/egjs-infinitegrid/docs
*/
import { FrameInfiniteGrid, MasonryInfiniteGrid } from '@egjs/vue3-infinitegrid'

export default defineNuxtPlugin((nuxtApp) => {
  /*
  * Fix Events Warn
  */
  const WrappedFrameInfiniteGrid = {
    ...FrameInfiniteGrid,
    emits: ['request-prepend', 'request-append', 'change-scroll', 'render-complete']
  }

  const WrappedMasonryInfiniteGrid = {
    ...MasonryInfiniteGrid,
    emits: ['request-prepend', 'request-append', 'change-scroll', 'render-complete']
  }

  /*
  * Return
  */
  nuxtApp.vueApp.component('FrameInfiniteGrid', WrappedFrameInfiniteGrid)
  nuxtApp.vueApp.component('MasonryInfiniteGrid', WrappedMasonryInfiniteGrid)
})